// IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #105987: ссылки фактов причин — список ссылок строки): ФАКТЫ ФОРМЫ ЯЧЕЙКИ (CellStory.vue — причины, параметры
// решения, строки политик) — [подпись, значение, ссылки?]. Контракт бэка (common_modules/reason_explain.py «ССЫЛКИ СТРОК», cell_story_causes.py «Ответ»): третий элемент — СПИСОК
// ссылок этой строки {kind: 'rule' | 'node' | 'doc' | 'batch' | …, id, segment, version?, title}, title каждой — подстрока значения, по порядку появления (бой fe-2026-10-26-3:
// факт ['Rule', 'P003', [{kind: 'rule', id, segment: 'MAP-Distr', title: 'P003'}]] рисовался текстом — фронт ждал ОДИН объект). Прежний вид фронта (строки story_solutionRows /
// story_policyRows) — один объект-ссылка: ссылкой становится всё значение. Чистые функции, без Vue и i18n (tests/unit/cellStoryFacts.test.mjs).

// ссылку можно открыть: id и сегмент записи (= прежний CellStory.linkOk)
export function factLinkOk(l) {
    return !!(l && typeof l === 'object' && !Array.isArray(l) && l.id && l.segment)
}

// значение факта → куски [{text, link?}]: значение режется по title каждой открываемой ссылки (поиск — с конца предыдущего совпадения); title не найден в значении —
// ссылка отдельным куском после значения через пробел (текст — title, нет — id); ссылка без id / сегмента — пропускается; links — объект (прежний вид: всё значение),
// массив или ничего. Склейка кусков без «хвостовых» ссылок всегда даёт исходное значение
export function factPieces(value, links) {
    const s = String(value ?? '')
    if (factLinkOk(links)) return [{ text: s, link: links }]
    if (!Array.isArray(links)) return [{ text: s }]
    const out = [], tail = []
    let cur = 0
    for (const l of links) {
        if (!factLinkOk(l)) continue
        const t = String(l.title ?? '')
        const i = t ? s.indexOf(t, cur) : -1
        if (i < 0) { tail.push(l); continue }
        if (i > cur) out.push({ text: s.slice(cur, i) })
        out.push({ text: t, link: l })
        cur = i + t.length
    }
    if (cur < s.length || !out.length) out.push({ text: s.slice(cur) })
    for (const l of tail) { out.push({ text: ' ' }); out.push({ text: String(l.title || l.id), link: l }) }
    return out
}
